export default __webpack_public_path__ + "static/media/mongo.bb6df587.png";